module.exports = __webpack_public_path__ + "img/q3-roll-03.e2241792.svg";